import { Navbar, Nav, Container } from "react-bootstrap";

import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Navigation.css';

function Navigation() {
    return (
      <Navbar>
      <Container>
        <Navbar.Brand href="/" className="Navigation-text">home</Navbar.Brand>
        <Nav>
          <Nav.Link href="/about" className="Navigation-text">about</Nav.Link>
          <Nav.Link href="/experience" className="Navigation-text">experience</Nav.Link>
          <Nav.Link href="/stuff" className="Navigation-text">stuff</Nav.Link>
        </Nav>
      </Container>
      </Navbar>
    )
}

export default Navigation;